import React from "react";

const ShoppingCartEmptyCard = ({
  orderFavoritesLink,
  orderHistoryLink,
  shopCatalogLink,
  translationKey,
  currentFileRequired,
}) => {
  return (
    <div className="empty-card-container">
      <div className="shopping-cart-empty-card-header">
        {translationKey(currentFileRequired["SHOPPING_CART"])}
      </div>
      <div className="shopping-cart-empty-card-content">
        <span className="empty-cart-message">
          {translationKey(currentFileRequired["CART_EMPTY_MESSAGE"])}{" "}
        </span>
        <div className="link-items">
          <a href={orderFavoritesLink} className="link-item">
            {translationKey(currentFileRequired["SHOP_YOUR_FAVORITES"])}
          </a>
          <span>|</span>
          <a href={orderHistoryLink} className="link-item">
            {translationKey(currentFileRequired["SHOP_ORDER_HISTORY"])}{" "}
          </a>
          <span>|</span>
          <a href={shopCatalogLink} className="link-item">
            {translationKey(currentFileRequired["CATALOG"])}
          </a>
        </div>
      </div>
    </div>
  );
};
export default ShoppingCartEmptyCard;
